/* eslint-disable max-len */
import React, {useState} from 'react'
import {connect} from 'react-redux'

import {Button} from '@lazarusai/forms-ui-components'

import stylesFileUpload from '../styles/FileUpload.module.css'

function FileUpload(props) {
  const [fileDrag, setFileDrag] = useState(false)
  const [moveInput, setMoveInput] = useState(false)

  function dragEnter(e) {
    e.preventDefault()
    setFileDrag(true)
    setMoveInput(true)
  }

  function dragDrop(e) {
    e.preventDefault()
    // e.target.value = null
    e.stopPropagation()
    setFileDrag(false);
    setMoveInput(false);
    props.onChangeFile(e)
  }

  function dragLeave(e) {
    e.preventDefault()
    setFileDrag(false)
    setMoveInput(false);
  }

  function dragOver(e) {
    e.preventDefault()
    e.stopPropagation()
    setFileDrag(true)
  }

  return (
    <div
      className={`${stylesFileUpload['file-upload']} ${fileDrag ? stylesFileUpload['border-highlight'] : ''}`}
    >
      <label
        htmlFor='file-input'
        onDragEnter={dragEnter}
        onDrop={dragDrop}
        onDragLeave={dragLeave}
        onDragOver={dragOver}
      >
        <Button
          theme={props.theme}
          text={'Files for VKG'}
          onClick={() => {
            document.getElementById('file-input').click()
          }}
        />
      </label>
      <input
        type='file'
        id='file-input'
        accept='.png, .jpg, .jpeg, .tiff, .tif, .heic, application/pdf'
        // multiple={props.selectedModel === 'genericFormApi2' ? false : true}
        multiple
        onChange={props.onChangeFile}
        onClick={(e) => {
          e.target.value = null
        }}
        style={{zIndex: moveInput ? '5' : '-1'}}
        onDrop={dragDrop}
        onDragLeave={dragLeave}
      />
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  theme: state.userReducer.theme,
  selectedModel: state.userReducer.selectedModel,
})

export default connect(
    mapStateToProps,
    {},
)(FileUpload)
